import { useTranslation } from "react-i18next";

export const JointBillServiceProviderBadge: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex size-9 items-center justify-center rounded-lg border border-grey-light bg-base-white">
      <img
        className="size-4"
        src="/favicon.ico"
        alt={t("altText.providerName")}
      />
    </div>
  );
};
